import {LayoutContent, PageFilter} from './../constant/LayoutContent';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LayoutService {
    private layoutContent: string[] = LayoutContent;
    private pageFilter: { [key: string]: { [key: string]: string[] } } = PageFilter;


    public showElement(name: string): boolean {
        return !!this.layoutContent.find((v) => v === name);
    }

    public showPageElement(page: string, section: string, name: string): boolean {
        if (this.pageFilter[page] && this.pageFilter[page][section] && this.pageFilter[page][section].find((v) => v === name)) {
            return true;
        }

        return false;
    }

    public filterByName(page: string, section: string, name: string, strictEq: boolean = false): boolean {
        if (!PageFilter[page] || !PageFilter[page][section]) return false;

        const filters = PageFilter[page][section];
        return filters.some(v => strictEq ? name === v : name.includes(v));
    }
}
